<template>
  <h2>Camp Locations</h2>

  <div id="topContainer">

    <div id="creatNewCampLocationButtonAndLabel">
      <label class="subHeaderFont" for="createNewCampButton">Create New Camp Location: </label>

      <div id="createNewCampButton" class="material-icons-outlined forCreateRecordIcon" data-tooltip="tooltip"
        title="Create" @click="this.$refs.createNewCampLocationModal.ShowModal();"> add_card </div>
    </div>

    <div class="radioContainer" id="radioContainerActiveButtons">

      <div class="form-check">
        <input class="form-check-input" type="radio" :value="false" v-model="showAllActiveOrInactive"
          @change="ShowAllActiveClicked('active')" ref="activeRadio" aria-label="Show Active Records">
        <label class="form-check-label" for="flexRadioDefault1" @click="this.$refs.activeRadio.click();">
          Active
        </label>
      </div>

      <!-- {{showAllActiveOrInactive}} -->
      <div class="form-check">
        <input class="form-check-input" type="radio" :value="true" v-model="showAllActiveOrInactive"
          @change="ShowAllActiveClicked('all')" ref="allRadio"  aria-label="Show All Records">
        <label class="form-check-label" for="flexRadioDefault1" @click="this.$refs.allRadio.click();">
          All
        </label>
      </div>


    </div>


  </div>


  <ModalBootstrap ModalId="createNewCampLocationModal" ModalTitle="Create a New Camp Location" ButtonText=""
    ref="createNewCampLocationModal">

    <template v-slot:body>
      <CampLocationForm :loaded-camp-location="{ campName: '', countryId: '-1' }"
        @camp-location-form-submitted="CreateFormSubmitted" ref="campLocationNewForm"></CampLocationForm>
    </template>

    <template v-slot:footer>

      <button type="button" class="btn btn-secondary"
        @click="this.$refs.createNewCampLocationModal.HideModal();">Cancel</button>
      <button type="button" class="btn btn-primary" data-dismiss="modal"
        @click="this.$refs.campLocationNewForm.Submit()">Save</button>

    </template>
  </ModalBootstrap>

  <ModalBootstrap ModalId="editCampLocationModal" ModalTitle="Edit Camp Location" ButtonText=""
    ref="editCampLocationModal" @modal-close-event="EditModalClosed">
    <template v-slot:body>
      <CampLocationForm :loaded-camp-location="this.campEditing" @camp-location-form-submitted="EditFormSubmitted"
        ref="campLocationEditForm"></CampLocationForm>
    </template>

    <template v-slot:footer>

      <button type="button" class="btn btn-secondary"
        @click="this.$refs.editCampLocationModal.HideModal();">Cancel</button>
      <button type="button" class="btn btn-primary" data-dismiss="modal"
        @click="this.$refs.campLocationEditForm.Submit()">Save Changes</button>

    </template>
  </ModalBootstrap>

  <DataTableComponent v-if="this.getAllCampLocationsUrl" :data-url="this.getAllCampLocationsUrl"
    :column-list-d-b="this.campLocationColumnNames" :column-list-pretty="this.campLocationColumnNamesPretty"
    column-name-id="campLocationId" :show-search="true" :center-column-indexes="[1]" plural-data-name="Camp Locations"
    ref="campLocationDataTable">

    <template v-slot:extraColumnHeaders>
      <th>Active</th>
    </template>

    <template #extraColumns="extraColumnRowData">
      <td :data-sort="extraColumnRowData.isActive">
        <div class="form-check activeCheckBoxContainer">
          <input class="form-check-input" type="checkbox" value=""
            :id="'flexCheckDefault_' + extraColumnRowData.campLocationId" @change="ActiveCheckboxHit(extraColumnRowData)"
            v-model="extraColumnRowData.isActive" aria-label="Check box to make record Active">
        </div>
      </td>
    </template>

    <template #actionColumnEditSlot="actionColumnEditSlot">

      <td class="actionColumn tdclass">

        <div class="material-icons forIconEdit text-success" data-tooltip="tooltip" title="Edit Record"
          @click="this.ShowEditModal(actionColumnEditSlot)"> edit </div>

      </td>

    </template>

  </DataTableComponent>
</template> 
  
<script>

import { store } from "@/store/store.js";
import $ from "jquery";
import DataTableComponent from "@/components/dataSupport/DataTable.vue";
import ModalBootstrap from "@/components/dataSupport/ModalBootstrap.vue";
import CampLocationForm from "./CampLocationForm.vue";

export default {
  name: "contractTable",
  components: {
    DataTableComponent, ModalBootstrap, CampLocationForm
  },
  created() {
    this.getAllCampLocationsUrl = store.webAPIUrl + "camplocations/GetAllByActiveDTO/" + this.showAllActiveOrInactive;
  },
  data() {
    return {
      getAllCampLocationsUrl: "",
      campLocationColumnNames: ['campName', 'countryName'],
      campLocationColumnNamesPretty: ['Location', 'Country'],
      campEditing: {},
      campToDelete: {},
      showAllActiveOrInactive: false
    };
  },
  methods: {
    ShowEditModal(_camp) {
      this.campEditing = _camp;

      this.$refs.editCampLocationModal.ShowModal();
      this.$refs.campLocationEditForm.editedCampLocation = _camp;
    },
    ShowDeleteModal(_camp) {
      this.campToDelete = _camp;

      this.$refs.deleteCampLocationModal.ShowModal();
    },
    EditModalClosed() {
      this.campEditing = {};
    },
    EditFormSubmitted() {
      this.$refs.editCampLocationModal.HideModal();
      console.log("edit submitted", this.showAllActiveOrInactive)
      this.$refs.campLocationDataTable.LoadDataAndInitializeTable(store.webAPIUrl + "CampLocations/GetAllByActiveDTO/" + this.showAllActiveOrInactive);
    },
    CreateFormSubmitted() {
      this.$refs.createNewCampLocationModal.HideModal();
      this.$refs.campLocationDataTable.LoadDataAndInitializeTable(store.webAPIUrl + "CampLocations/GetAllByActiveDTO/" + this.showAllActiveOrInactive);
    },
    ActiveCheckboxHit(editRow) {

      //get dataTable row by Id:
      var DataRowToEdit = this.$refs.campLocationDataTable.loadedData.find(x => x.campLocationId == editRow.campLocationId);
      //update data in table:
      DataRowToEdit.isActive = editRow.isActive;
      DataRowToEdit.activeStatus = editRow.isActive ? "Active" : "Inactive";
      //update data in DB:
      var actionUrl = store.webAPIUrl + "CampLocations/" + editRow.campLocationId;

      //set update date to now
      editRow.updateDate = new Date();

      $.ajax({
        method: "PUT",
        data: JSON.stringify(editRow),
        contentType: "application/json; charset=utf-8",
        dataType: "json",
        url: actionUrl,
        success: (result) => {

          this.successMessage = "Successfully Submitted Change to DB on: " + Date().toLocaleString() + "; " + result;
        },
      });

    },
    ShowAllActiveClicked(tableType) {
      if (tableType == "all") {
        this.$refs.campLocationDataTable.LoadDataAndInitializeTable(store.webAPIUrl + "CampLocations/GetDTO");
      }
      else {
        this.$refs.campLocationDataTable.LoadDataAndInitializeTable(store.webAPIUrl + "CampLocations/GetAllByActiveDTO/false");
      }
    }

  },
  unmounted() {

    //console.log("lkjdf"); 
    this.$forceUpdate();
  }
}
</script>
  
<style scoped>
.campUl {
  text-align: left;
}

.forIconEdit {
  cursor: pointer;
  color: #0f63a8 !important;
}

p {
  text-align: left;
}

.activeCheckBoxContainer {
  padding-bottom: 1.25rem;
}

.radioContainer {
  margin-bottom: 1rem;
}

#topContainer {
  display: flex;
}

#creatNewCampLocationButtonAndLabel {
  width: 270px;
  display: flex;
  justify-content: space-between;
}

#radioContainerActiveButtons {
  width: 185px;
  display: flex;
  justify-content: space-evenly;
}
</style>
